"use client";

import React from "react";
import { Grid, Stack, Box } from "@mui/material";
import { SectionHeader } from "@/components/common/section-header";
import { PlacesDiscover } from "@/types/dto/homepage/homepage-types";
import { ColletteButton } from "@collette-travel/collette-common-controls";
import PlacesDiscoverCard from "./places-discover-card";

interface PlacesToDiscoverProps {
  placesData: PlacesDiscover;
  moduleRankingPosition?: number;
  bgColor?: string;
}

const PlacesToDiscover = ({
  placesData,
  moduleRankingPosition = 7,
  bgColor
}: PlacesToDiscoverProps) => {
  const { basicInfo, destinationCards } = placesData || {};

  return (
    <Box
      data-track="visibility"
      data-testid="destination-section-container"
      data-module-name="Destination Section"
      data-ranking-algorithm="manual"
      data-module-ranking-position={moduleRankingPosition}
      component="section"
      className="fluid-box"
      sx={{ bgcolor: bgColor || "background.warm_strong" }}
    >
      <Stack
        className="full-width-container"
        gap="40px"
        sx={{
          padding: {
            xs: "4rem 2.4rem", // <600px
            md: "4rem 10rem" // >=600px and <1440px
          },
          alignItems: "center"
        }}
      >
        <SectionHeader
          headerText={basicInfo?.headerText}
          copyText={basicInfo?.copyText?.replace(/<p>/g, "").replace(/<\/p>/g, "")}
          headerTestId="discover-header"
          copyTestId="discover-subheader"
          headerSx={{
            fontSize: { xs: "26px", sm: "28px", md: "32px" },
            fontWeight: "600",
            textAlign: "center",
            textTransform: "none!important"
          }}
          copySx={{ textAlign: "center" }}
          sx={{
            textAlign: "center",
            maxWidth: { sm: "650px" },
            alignSelf: "center"
          }}
        />
        <Stack gap="24px" sx={{ width: "100%" }}>
          <Grid container spacing="20px">
            {destinationCards &&
              destinationCards.map((card, index: number) => (
                <Grid
                  key={card.id || index}
                  size={{ xs: 12, sm: index === 6 ? 12 : 6, md: index < 3 ? 4 : 3 }}
                  data-testid={`${index}_grid-item`}
                >
                  <PlacesDiscoverCard cardData={card} index={index} />
                </Grid>
              ))}
          </Grid>
          <ColletteButton
            component="a"
            href={basicInfo?.callToActionUrl}
            rel="noopener noreferrer"
            label="See All Destinations"
            testId="see-all-destinations"
            data-track="click"
            variant="outlined"
            size="large"
            sx={{
              alignSelf: "center",
              bgcolor: "background.default"
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default PlacesToDiscover;
